module.exports = __webpack_public_path__ + "static/media/check-box-empty.d5f04ac7.svg";